import * as http from 'axios'
const defaultEndpoint = require('@/endpoint')

export const busca = (filtro) => {
  delete filtro.tipoPedido
  return http.get(defaultEndpoint.urlGrupoSin + '/api/consultas', {params: filtro})
}
export const buscaExame = (filtro) => {
  delete filtro.tipoPedido
  return http.get(defaultEndpoint.urlGrupoSin + '/api/exames', {params: filtro})
}



// WEBPACK FOOTER //
// ./src/store/formBusca/services.js